import { render } from "./AlarmCenter.vue?vue&type=template&id=4d63a3ba&scoped=true"
import script from "./AlarmCenter.vue?vue&type=script&lang=js"
export * from "./AlarmCenter.vue?vue&type=script&lang=js"

import "./AlarmCenter.vue?vue&type=style&index=0&id=4d63a3ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d63a3ba"]])

export default __exports__